import { Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

export const DashboardTitle: FC<PropsWithChildren> = ({ children }) => {
	return (
		<Typography variant="subtitle1" fontWeight="500" bgcolor="grey.100" px={1} py={0.5}>
			{children}
		</Typography>
	);
};
